var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.45455 6.45455 2 12 2C17.5455 2 22 6.45455 22 12C22 17.5455 17.5455 22 12 22C6.45455 22 2 17.5455 2 12ZM3.81818 12C3.81818 16.5455 7.45455 20.1818 12 20.1818C16.5455 20.1818 20.1818 16.5455 20.1818 12C20.1818 7.45455 16.5455 3.81818 12 3.81818C7.45455 3.81818 3.81818 7.45455 3.81818 12ZM12 12.9091C12.5455 12.9091 12.9091 12.5455 12.9091 12V8.36364C12.9091 7.81818 12.5455 7.45455 12 7.45455C11.4545 7.45455 11.0909 7.81818 11.0909 8.36364V12C11.0909 12.5455 11.4545 12.9091 12 12.9091ZM11.0909 15.6364C11.0909 15.0909 11.4545 14.7273 12 14.7273C12.5455 14.7273 12.9091 15.0909 12.9091 15.6364C12.9091 16.1818 12.4545 16.5455 12 16.5455C11.5455 16.5455 11.0909 16.1818 11.0909 15.6364Z",
    fill: "#FABD00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.de59416c5fc85da39858c7a168c9fe56.svg";
export { ForwardRef as ReactComponent };